// WelcomeSlide — personalized greeting + role badge + value prop.

import { useAuth } from '@/context/AuthContext'
import { useOnboarding } from '../useOnboarding'
import SlideShell from './SlideShell'

const ROLE_BADGE: Record<string, { label: string; color: string }> = {
  CLIENT: { label: 'Client', color: 'bg-blue-100 text-blue-700' },
  WORKER: { label: 'Lucrător', color: 'bg-emerald-100 text-emerald-700' },
  COMPANY: { label: 'Companie', color: 'bg-amber-100 text-amber-700' },
  ADMIN: { label: 'Admin', color: 'bg-purple-100 text-purple-700' },
  GLOBAL_ADMIN: { label: 'Admin', color: 'bg-purple-100 text-purple-700' },
}

const VALUE_PROP: Record<string, string> = {
  CLIENT: 'Servicii profesionale la domiciliu, transparent și rapid.',
  WORKER: 'Joburi aproape de tine, plată la timp.',
  COMPANY: 'Echipă, comenzi și plăți într-un singur loc.',
  ADMIN: 'Centrul de operațiuni Go2Fix.',
  GLOBAL_ADMIN: 'Centrul de operațiuni Go2Fix.',
}

interface Props {
  progress: number
  onBack: () => void
}

export default function WelcomeSlide({ progress, onBack }: Props) {
  const { user } = useAuth()
  const { next } = useOnboarding()
  const role = (user?.role ?? 'CLIENT').toUpperCase()
  const firstName = (user?.fullName ?? '').split(' ')[0] || 'salutare'
  const badge = ROLE_BADGE[role] ?? ROLE_BADGE.CLIENT
  const value = VALUE_PROP[role] ?? VALUE_PROP.CLIENT

  return (
    <SlideShell
      progress={progress}
      onBack={onBack}
      footer={
        <button
          onClick={next}
          className="w-full bg-blue-600 active:bg-blue-700 active:scale-[0.99] transition text-white text-base font-medium px-4 py-3.5 rounded-xl"
        >
          Începem
        </button>
      }
    >
      <div className="flex flex-col items-center text-center pt-12">
        <div className="w-20 h-20 rounded-3xl bg-blue-100 flex items-center justify-center mb-6" aria-hidden="true">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9.5L12 3l9 6.5V20a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9.5z" />
            <path d="M9 22V12h6v10" />
          </svg>
        </div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
          Bună, {firstName}!
        </h1>
        <span className={'inline-block mt-3 px-3 py-1 rounded-full text-xs font-medium ' + badge.color}>
          {badge.label}
        </span>
        <p className="text-base text-gray-600 dark:text-gray-300 mt-6 max-w-sm">
          {value}
        </p>
      </div>
    </SlideShell>
  )
}
